<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">
            <strong>Família</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-show="showBox">
      <v-flex infoDados>
        <v-card>
          <v-data-table
            :headers="cabecalhoFamilia"
            :items="model.familiaSolicitacao"
            :hide-actions="true"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td
                class="text-xs-left"
              >{{props.item.familiaAssociada.codFamilia}} - {{props.item.familiaAssociada.descFamilia}}</td>
              <td class="text-xs-left">{{props.item.familiaAssociada.descGrupo}}</td>
              <td class="text-xs-left">{{props.item.familiaAssociada.tipoItem}}</td>
              <td class="text-xs-left">
                <span
                  v-show="Number(props.item.codGrupo)>9"
                >{{retornaEnumDescricao("tipoQualificacao",props.item.tipoQualificacao)}}</span>
              </td>
           
              <td class="text-xs-center naoImprimir">
              <a 
                v-show="props.item.anexoFamilia && props.item.anexoFamilia.arquivoUpload && props.item.anexoFamilia.arquivoUpload !== 'Não Encontrado'"
              >
                <v-icon 
                  :color="(
                    props.item.anexoFamilia &&
                    props.item.anexoFamilia.arquivoUpload &&
                    props.item.anexoFamilia.anexoFamiliaSituacao === 2
                  ) 
                    ? 'blue' 
                    : (
                      props.item.anexoFamilia &&
                      props.item.anexoFamilia.anexoFamiliaSituacao === 1 &&
                      props.item.anexoFamilia.arquivoUpload &&
                      props.item.anexoFamilia.arquivoUpload.includes('.pdf')
                    )
                      ? 'red'
                      : 'grey'"
                  :disabled="!(
                    props.item.anexoFamilia &&
                    props.item.anexoFamilia.arquivoUpload &&
                    (
                      props.item.anexoFamilia.arquivoUpload.includes('https') || 
                      (
                        props.item.anexoFamilia.anexoFamiliaSituacao === 1 && 
                        props.item.anexoFamilia.arquivoUpload.includes('.pdf')
                      )
                    )
                  )"
                  @click.native="handleIconClick(props.item.anexoFamilia.arquivoUpload, props.item.anexoFamilia.anexoFamiliaSituacao)"
                >
                  attach_file
                </v-icon>
              </a>
            </td>

            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import fornecedorService from "../../../services/fornecedorService";
import util from "../../../plugins/util";
export default {
  name: "resumo-familia",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio: Object,
    enums: Object
  },
  created() /*Metodo de start do componente*/{},
  data() {//Declaracao de variaveis
    return {
      showBox: true,
    };
  },
  methods: {//Declaracao de todos os metodos
    openBox() {
      this.showBox = !this.showBox;
    },

    retornaEnumDescricao(_enum, valor) {
      //retorna a descrição do enum
      if (!valor || !this.enums[_enum]) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao : null;
    },
    handleIconClick(arquivo,situacao) {
  
        if (arquivo.includes('https')) {
          window.open(arquivo, '_blank');
        } else if (situacao === 1 && arquivo.includes('.pdf')) {
          this.baixarArquivo(arquivo);
        }
      },
    
    baixarArquivo(arquivo) {  
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "") ;         
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
      },

    exibeDocumentoAnexoFamilia(anexoFamilia){
      if(anexoFamilia != undefined){
          return (anexoFamilia.arquivoUpload != undefined && anexoFamilia.arquivoUpload !== 'Não Encontrado');
      }else{
        return false;
      }
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoDados .v-card {
  padding: 15px;
}

.infoDados .linhaInfo {
  display: block;
  padding: 5px 0;
}

.theme--light.v-table thead {
  background: none;
}
</style>


